export type CultivarSaveSection =
  | "field"
  | "fertilizer"
  | "pesticides"
  | "irrigation"
  | "fuelUse"
  | "landUse";

const SAVE_REMINDER_MESSAGES: Record<CultivarSaveSection, string> = {
  field: "Please click the Update button to save your field details.",
  fertilizer:
    'Click "+" to add fertilizer entries as needed. Hit "Save/Update" when done — entries won\'t be saved until then.',
  pesticides:
    'Click "+" to add pesticide entries as needed. Hit "Save/Update" when done — entries won\'t be saved until then.',
  irrigation:
    'Click "+" to add irrigation entries as needed. Hit "Save/Update" when done — entries won\'t be saved until then.',
  fuelUse:
    'Click "+" to add fuel use entries as needed. Hit "Save/Update" when done — entries won\'t be saved until then.',
  landUse:
    'Select "Yes" if land use data is available, then use "+" to add entries. Don\'t forget to hit "Save/Update" — entries won\'t be saved until then.'
};

type CultivarSaveReminderProps = {
  section: CultivarSaveSection;
  hidden?: boolean;
};

const CultivarSaveReminder = ({ section, hidden = false }: CultivarSaveReminderProps) => {
  if (hidden) {
    return null;
  }

  return (
    <p className="tw-text-xs tw-text-muted-foreground tw-italic">
      {SAVE_REMINDER_MESSAGES[section]}
    </p>
  );
};

export default CultivarSaveReminder;
